/* Americanflat collection page — sort dropdown auto-submits its form;
   mobile "Filter & Sort" drawer open/close. */
(function () {
  document.querySelectorAll('[data-af-sort]').forEach((sel) => {
    sel.addEventListener('change', () => sel.form.submit());
  });

  // Filter form: on desktop, any facet change applies instantly. On mobile the
  // shopper multi-selects freely and only "View Results" submits.
  // Price inputs are excluded — they apply only via their own "Apply" button
  // (otherwise typing + blurring a price would search before you're done).
  const filterForm = document.getElementById('AfCollFilters');
  const isDesktop = () => window.matchMedia('(min-width: 901px)').matches;
  if (filterForm) {
    filterForm.querySelectorAll('[data-af-facet]:not(.af-price-input)').forEach((el) => {
      el.addEventListener('change', () => {
        // Pooled colour buckets: the visible checkbox carries no name; its hidden
        // member inputs (one per underlying option value) are what serialize.
        // Keep them in lockstep before any submit.
        if (el.dataset.afGroup) {
          const wrap = el.closest('label');
          if (wrap) wrap.querySelectorAll('[data-af-group-member]').forEach((m) => { m.checked = el.checked; });
        }
        if (isDesktop()) filterForm.submit();
      });
    });

    // Mobile "View Results" applies all selections at once. That button sits in
    // the drawer footer OUTSIDE the <form> and associates only via its `form=`
    // attribute, which is unreliable for out-of-form submit buttons on some
    // mobile browsers — so submit the form explicitly here.
    document.querySelectorAll('[data-af-filter-apply]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        filterForm.submit();
      });
    });
  }

  // "Show more colors" — reveal the colours collapsed past the cap in a colour
  // facet, and swap the label so it can collapse again.
  document.querySelectorAll('[data-af-color-more]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const grid = btn.closest('[data-af-color-grid]');
      if (!grid) return;
      const expanded = grid.classList.toggle('af-color-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? 'Show fewer colors' : btn.dataset.moreLabel;
    });
  });

  // "Show more sizes" — reveal the sizes collapsed past the 16 the facet ranks
  // as most useful. Same contract as the colour toggle.
  document.querySelectorAll('[data-af-size-more]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const group = btn.closest('[data-af-size-group]');
      if (!group) return;
      const expanded = group.classList.toggle('af-size-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? 'Show fewer sizes' : btn.dataset.moreLabel;
    });
  });

  // "Show more" for the Collection facet — reveal branded collections past the cap.
  document.querySelectorAll('[data-af-coll-more]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const list = btn.closest('[data-af-coll-list]');
      if (!list) return;
      const expanded = list.classList.toggle('af-coll-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? 'Show fewer' : btn.dataset.moreLabel;
    });
  });

  // Mobile filter drawer
  const drawer = document.getElementById('AfFilterDrawer');
  const backdrop = document.querySelector('.af-filter-backdrop');
  const openBtn = document.querySelector('[data-af-filter-open]');
  if (drawer && openBtn) {
    const open = () => {
      drawer.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.classList.add('af-filter-open');
      openBtn.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      drawer.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.classList.remove('af-filter-open');
      openBtn.setAttribute('aria-expanded', 'false');
    };
    openBtn.addEventListener('click', open);
    document.querySelectorAll('[data-af-filter-close]').forEach((el) => {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }
})();
